// TODO: Tooltipコンポーネントを作り替えたためTooltip2の命名になっている
//       元々のTooltipパーツは削除予定のため、削除後はTooltip２→Tooltipへimport名を変更
import { memo } from "react";
import * as Styled from "./style";
import { useCheckPriceDownNotice } from "~/components/blocks/layout/global-navi/common/price-down-tooltip/hooks/use-check-price-down-notice";
import { useViewableRatingBlock } from "~/hooks/use-viewable-rating-block";

type PriceDownTooltipProps = {
  isDesktop: boolean;
};

export const PriceDownTooltip = memo(({ isDesktop }: PriceDownTooltipProps) => {
  const { shouldShowPriceDownNotice } = useCheckPriceDownNotice();

  const { isAdultLinkAllowed } = useViewableRatingBlock();

  if (!isAdultLinkAllowed) return null;

  if (!shouldShowPriceDownNotice) return null;

  return (
    <Styled.Tooltip
      isDesktop={isDesktop}
      fontSize="XXS"
      fontColor="GRAY1000"
      positionTop={isDesktop ? undefined : "-1px"}
      positionBottom={isDesktop ? "-1px" : undefined}
      positionLeft="50%"
      transform={isDesktop ? "translate(-50%, 100%)" : "translate(-50%, -100%)"}
      backgroundColor="RED900"
      arrowDirection={isDesktop ? "top" : "bottom"}
    >
      値下がりした作品があります
    </Styled.Tooltip>
  );
});

PriceDownTooltip.displayName = "PriceDownTooltip";
